import { LegendOptions } from '@sprinklr/stories/hyperspaceWidgets/types';
import { observable } from 'mobx';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { LegendOptionsImpl } from '../options';

import { HyperSpaceComboChartWidgetOptions } from './types';

export class HyperSpaceComboChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceComboChartWidgetOptions {
    @observable baseXYChartOptions: HyperSpaceComboChartWidgetOptions['baseXYChartOptions'] = {
        grid: {
            enabled: false,
        },
        series: [
            {
                type: 'line',
            },
            {
                type: 'column',
            },
        ],
        xAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
        yAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                //TODO: how should we actually set initial value
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
    };
    @observable zeroFill = true;
    @observable legend: LegendOptions = new LegendOptionsImpl();
    @observable metaInfoOptions: HyperSpaceComboChartWidgetOptions['metaInfoOptions'] = {
        color: {
            enabled: false,
            type: 'fill',
        },
    };
}
